module.exports = __webpack_public_path__ + "img/img_31.a351e125.png";